import Modal, { ModalContent, ModalFooter, ModalHeader, useModal } from "@edgetier/modal";
import toast from "react-hot-toast";
import { axios } from "utilities/axios";
import { Button } from "@edgetier/components";
import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import { FunctionComponent, memo, useState } from "react";
import { getServerError } from "utilities/get-server-error";
import { IProps } from "./delete-phrase-trigger-result.types";
import { removeFromCache } from "./delete-phrase-trigger-result.utilities";
import { Route } from "@edgetier/watchtower-types";
import { trackUser } from "utilities/track-user";
import { useQueryClient } from "react-query";
import "./delete-phrase-trigger-result.scss";

/**
 * Button with confirmation modal for removing a phrase trigger result
 */
const DeletePhraseTriggerResult: FunctionComponent<IProps> = ({ phraseTriggerResultId }) => {
    const { closeModal, openModal, modalProps } = useModal();
    const queryClient = useQueryClient();
    const [isLoading, setIsLoading] = useState(false);

    /**
     * Make a DELETE request to API to delete the phrase trigger result.
     */
    const deletePhraseTriggerResult = async () => {
        try {
            setIsLoading(true);
            await axios.delete(Route.PhraseTriggersResult.replace(":phraseTriggerResultId", phraseTriggerResultId));
            removeFromCache(queryClient, phraseTriggerResultId);
            toast.success("Tag successfully removed");
            trackUser("Remove Tag From Message", { phraseTriggerResultId });
            closeModal();
        } catch (serverError) {
            toast.error(getServerError(serverError));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div onClick={(event) => event.stopPropagation()}>
            <Button styleName="negative" outline onClick={openModal}>
                Remove Tag
            </Button>
            <Modal {...modalProps}>
                <ModalHeader>
                    <h2>Remove Tag</h2>
                </ModalHeader>
                <ModalContent>
                    <p>
                        Are you sure you want to remove this tag from the message? Please note that if this is the only
                        message in the interaction with this tag, the tag will also be removed from the interaction.
                    </p>
                </ModalContent>
                <ModalFooter>
                    <Button
                        icon={faTrashAlt}
                        isLoading={isLoading}
                        onClick={deletePhraseTriggerResult}
                        styleName="negative"
                    >
                        Yes, Remove tag
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default memo(DeletePhraseTriggerResult);
